<template>
    <div v-if="selectedElement && selectedElement.itemType != 'page_element'" class="editor-template-styles-properties">
        <template v-if="activeTab == 'layout'">
            <EditorPropertyPanel :title="selectedElement.itemType == 'text_element' ? 'Background' : 'Size & Background'"
                :expandedInit="true">
                <EditorProperty v-if="selectedElement.itemType != 'text_element'" title="Width">
                    <div class="row">
                        <DropdownWidget style="width:100%" :options="sizeTypeOptions" :value="widthSizeTypeValue"
                            @input="onWidthSizeTypeValueChange">
                        </DropdownWidget>
                        <div v-if="widthSizeTypeValue == 'default'" style="margin-left: 2px;"></div>
                        <DropdownNumberWidget v-if="widthSizeTypeValue == 'default'" :options="sizeOptions"
                            :value="elementWidthValue" @input="onElementWidthValueChange">
                        </DropdownNumberWidget>
                    </div>
                </EditorProperty>

                <EditorProperty v-if="selectedElement.itemType != 'text_element'" title="Height">
                    <div class="row">
                        <DropdownWidget style="width:100%" :options="sizeTypeOptions" :value="heightSizeTypeValue"
                            @input="onHeightSizeTypeValueChange">
                        </DropdownWidget>
                        <div v-if="heightSizeTypeValue == 'default'" style="margin-right: 2px;"></div>
                        <DropdownNumberWidget v-if="heightSizeTypeValue == 'default'" :options="sizeOptions"
                            :value="elementHeightValue" @input="onElementHeightValueChange">
                        </DropdownNumberWidget>
                    </div>
                </EditorProperty>

                <EditorProperty title="Background Color">
                    <ColorWidget :value="elementBackgoundColorValue" @input="onElementBackgoundColorValueChange">
                    </ColorWidget>
                </EditorProperty>

            </EditorPropertyPanel>
            <EditorPropertyPanel title="Position">
                <EditorProperty title="Posion options" class="veritical">
                    <SelectWidget :options="positionTypeOptions" :value="positionType" @input="onPositionTypeChange">
                    </SelectWidget>
                </EditorProperty>

                <EditorProperty v-if="positionType == 'absolute'" title="Direction" class="veritical">
                    <DropdownNumberWidget :inputOptions="numberInputOptions" :options="sizeOptions" :value="positionValue"
                        @input="onPositionValueChange">
                    </DropdownNumberWidget>
                </EditorProperty>

            </EditorPropertyPanel>
            <EditorPropertyPanel title="Content Layout">
                <EditorProperty v-if="false" title="Type">
                    <SelectWidget :options="layoutTypeOptions" :value="elementLayoutTypeValue"
                        @input="onElementLayoutTypeValueChange">
                    </SelectWidget>
                </EditorProperty>
                <EditorProperty title="Direction" class="veritical">
                    <SelectWidget :options="layoutDirectionOptions" :value="elementLayoutDirectionValue"
                        @input="onElementLayoutDirectionValueChange">
                    </SelectWidget>
                </EditorProperty>
                <EditorProperty title="Distribute" class="veritical">
                    <DropdownWidget style="width: 100%;" :options="layoutDistributeOptions"
                        :value="elementLayoutDistributeValue" @input="onElementLayoutDistributeValueChange">
                    </DropdownWidget>
                </EditorProperty>
                <EditorProperty title="Wrap Content" class="veritical">
                    <DropdownWidget style="width: 100%;" :options="wrapOptions" :value="flexWrapValue"
                        @input="onElementWrapContentValueChange">
                    </DropdownWidget>
                </EditorProperty>

                <EditorProperty title="Align" class="veritical">
                    <SelectWidget :options="layoutAlignOptions" :value="elementLayoutAlignValue"
                        @input="onElementLayoutAlignValueChange">
                    </SelectWidget>
                </EditorProperty>
                <EditorProperty title="Gap">
                    <DropdownNumberWidget :options="sizeOptions" :value="elementLayoutGapValue"
                        @input="onElementLayoutGapValueChange">
                    </DropdownNumberWidget>
                </EditorProperty>
            </EditorPropertyPanel>
            <EditorPropertyPanel title="Adjust">
                <EditorProperty title="Padding" class="veritical">
                    <DropdownNumberWidget :inputOptions="numberInputOptions" :options="sizeOptions"
                        :value="elementLayoutPaddingValue" @input="onElementLayoutPaddingValueChange">
                    </DropdownNumberWidget>
                </EditorProperty>
                <EditorProperty title="Margin" class="veritical">
                    <DropdownNumberWidget :inputOptions="numberInputOptions" :options="sizeOptions"
                        :value="elementLayoutMarginValue" @input="onElementLayoutMarginValueChange">
                    </DropdownNumberWidget>
                </EditorProperty>
                <EditorProperty title="Border Style" class="veritical">
                    <div class="row">
                        <SelectWidget :options="borderTypeOptions" :value="elementBorderTypeValue"
                            @input="onElementBorderTypeValueChange">
                        </SelectWidget>
                        <div class="h-spacer"></div>
                        <ColorWidget :value="elementBorderColorValue" @input="onElementBorderColorValueChange">
                        </ColorWidget>
                    </div>
                    <div class="row" style="margin-top: 4px;">
                        <DropdownNumberWidget :inputOptions="numberInputOptions" :options="sizeOptions"
                            :value="elementBorderSizeValue" @input="onElementBorderSizeValueChange">
                        </DropdownNumberWidget>
                    </div>
                </EditorProperty>

                <EditorProperty title="Border Radius" class="veritical">
                    <DropdownNumberWidget :inputOptions="borderRadiusInputOptions" :options="sizeOptions"
                        :value="elementBorderRadiusValue" @input="onElementBorderRadiusValueChange">
                    </DropdownNumberWidget>
                </EditorProperty>

            </EditorPropertyPanel>
        </template>

        <template v-if="activeTab == 'format' && selectedElement.itemType == 'text_element'">
            <EditorPropertyPanel title="Text" :expandedInit="true">
                <EditorProperty title="Font" class="veritical">
                    <div class="row">
                        <DropdownWidget style="width:100%" :options="fontFamilyOptions" :value="textFontFamilyValue"
                            @input="onTextFontFamilyChange">
                        </DropdownWidget>
                        <div style="margin-left: 2px;"></div>
                        <DropdownNumberWidget :options="sizeOptions" :value="elementTextSizeValue"
                            @input="onElementTextSizeValueChange">
                        </DropdownNumberWidget>
                    </div>
                </EditorProperty>
                <EditorProperty title="Font Weight" class="veritical">
                    <DropdownWidget :options="fontWeightOptions" :value="textFontWeightValue"
                        @input="onTextFontWeightChange">
                    </DropdownWidget>
                </EditorProperty>
                <EditorProperty title="Font Style" class="veritical">
                    <DropdownWidget :options="fontStyleOptions" :value="textFontStyleValue" @input="onTextFontStyleChange">
                    </DropdownWidget>
                </EditorProperty>
                <EditorProperty title="Text Color" class="veritical">
                    <ColorWidget :value="elementTextColorValue" @input="onElementTextColorValueChange"></ColorWidget>
                </EditorProperty>
                <EditorProperty title="Text Align" class="veritical">
                    <DropdownWidget :options="textAlingOptions" :value="textAlignValue" @input="onTextAlignValueChange">
                    </DropdownWidget>
                </EditorProperty>
                <EditorProperty title="Text Decoration" class="veritical">
                    <DropdownWidget style="width:100%" :options="textDecorationOptions" :value="textDecorationValue"
                        @input="onTextDecorationChange">
                    </DropdownWidget>
                </EditorProperty>
                <EditorProperty title="Text Case" class="veritical">
                    <DropdownWidget :options="textCaseOptions" :value="textCaseValue" @input="onTextCaseChange">
                    </DropdownWidget>
                </EditorProperty>

                <EditorProperty title="Line Spacing" class="veritical">
                    <DropdownNumberWidget :options="sizeOptions" :value="textLineSpacingValue"
                        @input="onTextLineSpacingChange">
                    </DropdownNumberWidget>
                </EditorProperty>
                <EditorProperty title="Text Content" class="veritical">
                    <widgetTextarea :value="textContentValue" @input="onTextContentChange" placeholder="Enter text">
                    </widgetTextarea>
                </EditorProperty>
            </EditorPropertyPanel>



        </template>
        <template v-if="activeTab == 'format' && selectedElement.itemType == 'container_element'">
            <EditorPropertyPanel title="Content Section" :expandedInit="true">
                <EditorProperty title="Profile Content" class="veritical">
                    <SelectWidget :options="profileContentOptions" :value="profileContentSelectedValue"
                        @input="onProfileContentValueChange">
                    </SelectWidget>
                </EditorProperty>
            </EditorPropertyPanel>

        </template>
        <template v-if="activeTab == 'format' && selectedElement.itemType == 'image_element'">
            <EditorPropertyPanel title="Images from unsplash" :expandedInit="false">
                <EditorUnsplashImages @setImage="onImageSelected"></EditorUnsplashImages>
            </EditorPropertyPanel>
            <EditorPropertyPanel title="Background Section" :expandedInit="false">
                <EditorUploadBackground @setImage="onImageSelected"></EditorUploadBackground>
            </EditorPropertyPanel>
            <EditorPropertyPanel title="Content Section" :expandedInit="true">
                <EditorUploadImages @setImage="onImageSelected"></EditorUploadImages>
            </EditorPropertyPanel>

        </template>


    </div>
    <div v-else class="editor-template-styles-properties">
    </div>
</template>
<script>
import EditorPropertyPanel from "./editor_components/editor_property_panel.vue"
import EditorProperty from "./editor_components/editor_property.vue"
import DropdownWidget from "./input-widget/dropdown_widget.vue"
import NumberWidget from "./input-widget/number_widget.vue"
import DropdownNumberWidget from "./input-widget/dropdown_number_widget.vue"
import ProgressBarWidget from "./input-widget/progress_bar_widget.vue"
import SelectWidget from "./input-widget/select_widget.vue"
import ColorWidget from "./input-widget/color_widget.vue"
import EditorUploadImages from "./editor_components/editor_upload_images.vue"
import EditorUnsplashImages from "./editor_components/editor_unsplash_images.vue"
import EditorUploadBackground from "./editor_components/editor_upload_background.vue"
export default {
    name: "editor-template-styles-properties",
    components: {
        EditorPropertyPanel,
        EditorProperty,
        DropdownWidget,
        //NumberWidget,
        DropdownNumberWidget,
        // ProgressBarWidget,
        SelectWidget,
        ColorWidget,
        EditorUploadImages,
        EditorUnsplashImages,
        EditorUploadBackground
    },
    props: {
        selectedElement: {
            type: Object,
            default: () => {
                return null;
            }
        },
        activeTab: {
            type: String,
            default: "layout"
        }
    },
    data() {
        return {
            numberInputOptions: ['Top', 'Bottom', 'Left', 'Right'],
            borderRadiusInputOptions: ['Top-R', 'Bottom-R', 'Top-L', 'Bottom-L'],
            wrapOptions: [
                { value: "wrap", label: 'Yes' },
                { value: "unset", label: 'No' },
            ],
            profileContentOptions: [
                { value: true, label: 'Yes' },
                { value: false, label: 'No' },
            ],
            positionTypeOptions: [
                { value: 'relative', label: 'Default' },
                { value: 'absolute', label: 'Fluid' },
            ],
            sizeTypeOptions: [
                { value: 'default', label: 'Custom' },
                { value: 'match', label: 'Match Content' },
                { value: 'fill', label: 'Fill' },
            ],
            sizeOptions: [
                { value: '%', label: '%' },
                { value: 'px', label: 'px' },
                { value: 'em', label: 'em' },
                { value: 'rem', label: 'rem' },
                { value: 'vw', label: 'vw' },
                { value: 'vh', label: 'vh' },
                { value: 'vmin', label: 'vmin' },
                { value: 'vmax', label: 'vmax' },
            ],
            borderTypeOptions: [
                { value: 'solid', label: 'Solid' },
                { value: 'dashed', label: 'Doted' }
            ],
            layoutTypeOptions: [
                { value: 'flex', label: 'Stack' },
                { value: 'grid', label: 'Grid' },
            ],
            layoutAlignOptions: [
                { value: 'flex-start', label: 'Start' },
                { value: 'center', label: 'Center' },
                { value: 'flex-end', label: 'End' },
            ],
            layoutDirectionOptions: [
                {
                    value: 'row', label: 'Holizontal',
                    icon: {
                        left: {
                            active: require('@/views/Resume/icons/horizontal-active.svg'),
                            inactive: require('@/views/Resume/icons/horizontal-inactive.svg')
                        }
                    }
                },
                {
                    value: 'column', label: 'Vertical',
                    icon: {
                        left: {
                            active: require('@/views/Resume/icons/vertical-active.svg'),
                            inactive: require('@/views/Resume/icons/vertical-inactive.svg')
                        }
                    }
                },
            ],
            layoutDistributeOptions: [
                { value: 'flex-start', label: 'Start' },
                { value: 'center', label: 'Center' },
                { value: 'space-between', label: 'Between' },
                { value: 'flex-end', label: 'End' },
            ],
            fontFamilyOptions: [
                { value: 'Arial', label: 'Arial' },
                { value: 'Helvetica', label: 'Helvetica' },
                { value: 'Times New Roman', label: 'Times New Roman' },
                { value: 'Times', label: 'Times' },
                { value: 'Courier New', label: 'Courier New' },
                { value: 'Courier', label: 'Courier' },
                { value: 'Verdana', label: 'Verdana' },
                { value: 'Georgia', label: 'Georgia' },
                { value: 'Palatino', label: 'Palatino' },
                { value: 'Garamond', label: 'Garamond' },
                { value: 'Bookman', label: 'Bookman' },
                { value: 'Comic Sans MS', label: 'Comic Sans MS' },
                { value: 'Trebuchet MS', label: 'Trebuchet MS' },
                { value: 'Arial Black', label: 'Arial Black' },
                { value: 'Impact', label: 'Impact' },
            ],
            fontWeightOptions: [
                { value: '100', label: '100' },
                { value: '200', label: '200' },
                { value: '300', label: '300' },
                { value: '400', label: '400' },
                { value: '500', label: '500' },
                { value: '600', label: '600' },
                { value: '700', label: '700' },
                { value: '800', label: '800' },
                { value: '900', label: '900' },
            ],
            fontStyleOptions: [
                { value: 'normal', label: 'Normal' },
                { value: 'italic', label: 'Italic' },
                { value: 'bold', label: 'Bold' },
                { value: 'bold italic', label: 'Bold Italic' },
            ],
            textDecorationOptions: [
                { value: 'none', label: 'None' },
                { value: 'underline', label: 'Underline' },
                { value: 'overline', label: 'Overline' },
                { value: 'line-through', label: 'Line Through' },
            ],
            textCaseOptions: [
                { value: 'none', label: 'None' },
                { value: 'uppercase', label: 'Uppercase' },
                { value: 'lowercase', label: 'Lowercase' },
                { value: 'capitalize', label: 'Capitalize' },
            ],
            textAlingOptions: [
                { value: 'left', label: 'Left' },
                { value: 'center', label: 'Center' },
                { value: 'right', label: 'Right' },
                { value: 'justify', label: 'Justify' },
            ],

        };
    },
    computed: {
        flexWrapValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let flexWrap = selectedElement.flexWrap;
                if (flexWrap) {
                    return flexWrap;
                }
            }
            return 'unset';
        },
        profileContentSelectedValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let profileContent = selectedElement.isProfileContent;
                if (profileContent) {
                    return profileContent;
                }
            }
            return false;
        },
        positionType() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let position = selectedElement.position;
                if (position) {
                    return position;
                }
            }
            return 'unset';
        },
        positionValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let positions = vm.numberInputOptions.map(item => {
                    if (item == 'Top') {
                        return {
                            value: selectedElement.top,
                            type: item
                        }
                    }
                    if (item == 'Bottom') {
                        return {
                            value: selectedElement.bottom,
                            type: item
                        }
                    }
                    if (item == 'Left') {
                        return {
                            value: selectedElement.left,
                            type: item
                        }
                    }
                    if (item == 'Right') {
                        return {
                            value: selectedElement.right,
                            type: item
                        }
                    }
                });
                return positions;
            }
            return vm.numberInputOptions.map(item => {
                return {
                    value: '0px',
                    type: item
                }
            });
        },
        widthSizeTypeValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let widthSizeType = selectedElement.widthSizeType;
                if (widthSizeType) {
                    return widthSizeType;
                }
            }
            return 'default';
        },
        elementWidthValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let width = selectedElement.width;
                if (width == 'wrap-content') {
                    vm.$store.commit('SET_CV_SAVE_HISTORY', false);
                    vm.onWidthSizeTypeValueChange('match');
                    vm.$store.commit('SET_CV_SAVE_HISTORY', true);
                }
                if (width) {
                    return width;
                }
            }
            return 'unset';
        },
        heightSizeTypeValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let heightSizeType = selectedElement.heightSizeType;
                if (heightSizeType) {
                    return heightSizeType;
                }
            }
            return 'default';
        },
        elementHeightValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let height = selectedElement.height;
                if (height == 'wrap-content') {
                    vm.$store.commit('SET_CV_SAVE_HISTORY', false);
                    vm.onHeightSizeTypeValueChange('match');
                    vm.$store.commit('SET_CV_SAVE_HISTORY', true);
                }
                if (height) {
                    return height;
                }
            }
            return 'unset';
        },
        elementLayoutTypeValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let layoutType = selectedElement.display;
                if (layoutType) {
                    return layoutType;
                }
            }
            return 'unset';
        },
        elementLayoutDirectionValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let layoutDirection = selectedElement.flexDirection;
                if (layoutDirection) {
                    return layoutDirection;
                }
            }
            return 'unset';
        },
        elementLayoutDistributeValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let layoutDistribute = selectedElement.justifyContent;
                if (layoutDistribute) {
                    return layoutDistribute;
                }
            }
            return 'unset';
        },
        elementLayoutAlignValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let layoutAlign = selectedElement.alignItems;
                if (layoutAlign) {
                    return layoutAlign;
                }
            }
            return 'unset';
        },
        elementLayoutGapValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let layoutGap = selectedElement.gap;
                if (layoutGap) {
                    return layoutGap;
                }
            }
            return 'unset';
        },
        elementLayoutPaddingValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let layoutPadding = vm.numberInputOptions.map(item => {
                    if (item == 'Top') {
                        return {
                            value: selectedElement.paddingTop,
                            type: item
                        }
                    }
                    if (item == 'Bottom') {
                        return {
                            value: selectedElement.paddingBottom,
                            type: item
                        }
                    }
                    if (item == 'Left') {
                        return {
                            value: selectedElement.paddingLeft,
                            type: item
                        }
                    }
                    if (item == 'Right') {
                        return {
                            value: selectedElement.paddingRight,
                            type: item
                        }
                    }
                    return 0;
                });
                return layoutPadding;
            }
            return vm.numberInputOptions.map(item => {
                return {
                    value: '0px',
                    type: item
                }
            });
        },
        elementLayoutMarginValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let layoutMargin = vm.numberInputOptions.map(item => {
                    if (item == 'Top') {
                        return {
                            value: selectedElement.marginTop,
                            type: item
                        }
                    }
                    if (item == 'Bottom') {
                        return {
                            value: selectedElement.marginBottom,
                            type: item
                        }
                    }
                    if (item == 'Left') {
                        return {
                            value: selectedElement.marginLeft,
                            type: item
                        }
                    }
                    if (item == 'Right') {
                        return {
                            value: selectedElement.marginRight,
                            type: item
                        }
                    }
                });
                return layoutMargin;
            }
            return vm.numberInputOptions.map(item => {
                return {
                    value: '0px',
                    type: item
                }
            });
        },

        elementBorderTypeValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let borderType = selectedElement.borderType;
                if (borderType) {
                    return borderType;
                }
            }
            return 'unset';
        },
        elementBorderColorValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let borderTopColor = selectedElement.borderTopColor;
                if (borderTopColor) {
                    return borderTopColor;
                }
            }
            return 'unset';
        },
        elementBorderSizeValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let borderSize = vm.numberInputOptions.map(item => {
                    if (item == 'Top') {
                        return {
                            value: selectedElement.borderTopSize,
                            type: item
                        }
                    }
                    if (item == 'Bottom') {
                        return {
                            value: selectedElement.borderBottomSize,
                            type: item
                        }
                    }
                    if (item == 'Left') {
                        return {
                            value: selectedElement.borderLeftSize,
                            type: item
                        }
                    }
                    if (item == 'Right') {
                        return {
                            value: selectedElement.borderRightSize,
                            type: item
                        }
                    }
                });
                return borderSize;
            }
            return vm.numberInputOptions.map(item => {
                return {
                    value: '0px',
                    type: item
                }
            });

        },

        elementBorderRadiusValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let borderRadius = vm.borderRadiusInputOptions.map(item => {
                    if (item == 'Top-R') {
                        return {
                            value: selectedElement.borderTopRightRadius,
                            type: item
                        }
                    }
                    if (item == 'Bottom-R') {
                        return {
                            value: selectedElement.borderBottomRightRadius,
                            type: item
                        }
                    }
                    if (item == 'Top-L') {
                        return {
                            value: selectedElement.borderTopLeftRadius,
                            type: item
                        }
                    }
                    if (item == 'Bottom-L') {
                        return {
                            value: selectedElement.borderBottomLeftRadius,
                            type: item
                        }
                    }
                });
                return borderRadius;
            }
            return vm.borderRadiusInputOptions.map(item => {
                return {
                    value: '0px',
                    type: item
                }
            });

        },

        elementBackgoundColorValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let backgoundColor = selectedElement.backgoundColor;
                if (backgoundColor) {
                    return backgoundColor;
                }
            }
            return 'unset';
        },
        elementTextColorValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let textColor = selectedElement.textColor;
                if (textColor) {
                    return textColor;
                }
            }
            return 'unset';
        },
        textFontFamilyValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let fontFamily = selectedElement.fontFamily;
                if (fontFamily) {
                    return fontFamily;
                }
            }
            return 'unset';
        },
        textFontWeightValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let fontWeight = selectedElement.fontWeight;
                if (fontWeight) {
                    return fontWeight;
                }
            }
            return 'unset';
        },
        textFontStyleValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let fontStyle = selectedElement.fontStyle;
                if (fontStyle) {
                    return fontStyle;
                }
            }
            return 'unset';
        },
        textDecorationValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let textDecoration = selectedElement.textDecoration;
                if (textDecoration) {
                    return textDecoration;
                }
            }
            return 'unset';
        },
        textCaseValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let textCase = selectedElement.textCase;
                if (textCase) {
                    return textCase;
                }
            }
            return 'unset';
        },
        elementTextSizeValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let fontSize = selectedElement.fontSize;
                if (fontSize) {
                    return fontSize;
                }
            }
            return 'unset';
        },
        textContentValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let textContent = selectedElement.textValue;
                if (textContent) {
                    return textContent;
                }
            }
            return '';
        },
        textLineSpacingValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let textLineSpacing = selectedElement.textLineSpacing;
                if (textLineSpacing) {
                    return textLineSpacing;
                }
            }
            return 'unset';
        },
        textAlignValue() {
            let vm = this;
            let selectedElement = vm.selectedElement;
            if (selectedElement) {
                let textAlign = selectedElement.textAlign;
                if (textAlign) {
                    return textAlign;
                }
            }
            return 'unset';
        },

    },
    mounted() { },
    methods: {
        onPositionTypeChange(value) {
            let vm = this;
            vm.$emit('onPositionTypeChange', value);
        },
        onPositionValueChange(value) {
            let vm = this;
            value.forEach(item => {
                if (item.type == 'Top') {
                    vm.$emit('onPositionTopValueChange', item.value);
                } else if (item.type == 'Bottom') {
                    vm.$emit('onPositionBottomValueChange', item.value);
                } else if (item.type == 'Left') {
                    vm.$emit('onPositionLeftValueChange', item.value);
                } else if (item.type == 'Right') {
                    vm.$emit('onPositionRightValueChange', item.value);
                }
            })
        },
        onWidthSizeTypeValueChange(value) {
            let vm = this;
            vm.$emit('onWidthSizeTypeValueChange', value);
            if (value == 'fill') {
                vm.$emit('onElementWidthValueChange', '100%');
            } else if (value == 'match') {
                vm.$emit('onElementWidthValueChange', 'max-content');
            } else {
                vm.$emit('onElementWidthValueChange', '100%');
            }
        },
        onElementWidthValueChange(value) {
            let vm = this;
            vm.$emit('onElementWidthValueChange', value);
        },
        onElementHeightValueChange(value) {
            let vm = this;
            vm.$emit('onElementHeightValueChange', value);
        },
        onHeightSizeTypeValueChange(value) {
            let vm = this;
            vm.$emit('onHeightSizeTypeValueChange', value);
            if (value == 'fill') {
                vm.$emit('onElementHeightValueChange', '100%');
            } else if (value == 'match') {
                vm.$emit('onElementHeightValueChange', 'max-content');
            } else {
                vm.$emit('onElementHeightValueChange', '100%');
            }
        },
        onElementLayoutTypeValueChange(value) {
            let vm = this;
            vm.$emit('onElementLayoutTypeValueChange', value);
        },
        onElementLayoutDirectionValueChange(value) {
            let vm = this;
            vm.$emit('onElementLayoutDirectionValueChange', value);
        },
        onElementLayoutDistributeValueChange(value) {
            let vm = this;
            vm.$emit('onElementLayoutDistributeValueChange', value);
        },
        onElementLayoutAlignValueChange(value) {
            let vm = this;
            vm.$emit('onElementLayoutAlignValueChange', value);
        },
        onElementLayoutGapValueChange(value) {
            let vm = this;
            vm.$emit('onElementLayoutGapValueChange', value);
        },
        onElementLayoutPaddingValueChange(value) {
            let vm = this;
            value.forEach(item => {
                if (item.type == 'Top') {
                    vm.$emit('onElementLayoutPaddingTopValueChange', item.value);
                } else if (item.type == 'Bottom') {
                    vm.$emit('onElementLayoutPaddingBottomValueChange', item.value);
                } else if (item.type == 'Left') {
                    vm.$emit('onElementLayoutPaddingLeftValueChange', item.value);
                } else if (item.type == 'Right') {
                    vm.$emit('onElementLayoutPaddingRightValueChange', item.value);
                }
            })
        },
        onElementLayoutMarginValueChange(value) {
            let vm = this;
            value.forEach(item => {
                if (item.type == 'Top') {
                    vm.$emit('onElementLayoutMarginTopValueChange', item.value);
                } else if (item.type == 'Bottom') {
                    vm.$emit('onElementLayoutMarginBottomValueChange', item.value);
                } else if (item.type == 'Left') {
                    vm.$emit('onElementLayoutMarginLeftValueChange', item.value);
                } else if (item.type == 'Right') {
                    vm.$emit('onElementLayoutMarginRightValueChange', item.value);
                }
            })
        },

        onElementBorderTypeValueChange(value) {
            let vm = this;
            vm.$emit('onElementBorderTypeValueChange', value);
        },
        onElementBorderColorValueChange(value) {
            let vm = this;
            vm.$emit('onElementBorderTopColorValueChange', value);
            vm.$emit('onElementBorderBottomColorValueChange', value);
            vm.$emit('onElementBorderLeftColorValueChange', value);
            vm.$emit('onElementBorderRightColorValueChange', value);
        },

        onElementBorderSizeValueChange(value) {
            let vm = this;
            value.forEach(item => {
                if (item.type == 'Top') {
                    vm.$emit('onElementBorderTopSizeValueChange', item.value);
                } else if (item.type == 'Bottom') {
                    vm.$emit('onElementBorderBottomSizeValueChange', item.value);
                } else if (item.type == 'Left') {
                    vm.$emit('onElementBorderLeftSizeValueChange', item.value);
                } else if (item.type == 'Right') {
                    vm.$emit('onElementBorderRightSizeValueChange', item.value);
                }
            })
        },


        onElementBorderRadiusValueChange(value) {
            let vm = this;
            value.forEach(item => {
                if (item.type == 'Top-R') {
                    vm.$emit('onElementBorderTopRightRadiusValueChange', item.value);
                } else if (item.type == 'Bottom-R') {
                    vm.$emit('onElementBorderBottomRightRadiusValueChange', item.value);
                } else if (item.type == 'Top-L') {
                    vm.$emit('onElementBorderTopLeftRadiusValueChange', item.value);
                } else if (item.type == 'Bottom-L') {
                    vm.$emit('onElementBorderBottomLeftRadiusValueChange', item.value);
                }
            });
        },

        onElementBackgoundColorValueChange(value) {
            let vm = this;
            vm.$emit('onElementBackgoundColorValueChange', value);
        },
        onElementTextColorValueChange(value) {
            let vm = this;
            vm.$emit('onElementTextColorValueChange', value);
        },
        onTextFontFamilyChange(value) {
            let vm = this;
            vm.$emit('onTextFontFamilyChange', value);
        },
        onTextFontWeightChange(value) {
            let vm = this;
            vm.$emit('onTextFontWeightChange', value);
        },
        onTextFontStyleChange(value) {
            let vm = this;
            vm.$emit('onTextFontStyleChange', value);
        },
        onTextDecorationChange(value) {
            let vm = this;
            vm.$emit('onTextDecorationChange', value);
        },
        onTextCaseChange(value) {
            let vm = this;
            vm.$emit('onTextCaseChange', value);
        },
        onElementTextSizeValueChange(value) {
            let vm = this;
            vm.$emit('onElementTextSizeValueChange', value);
        },
        onTextContentChange(value) {
            let vm = this;
            vm.$emit('onTextContentChange', value);
        },
        onTextLineSpacingChange(value) {
            let vm = this;
            vm.$emit('onTextLineSpacingChange', value);
        },
        onTextAlignValueChange(value) {
            let vm = this;
            vm.$emit('onTextAlignValueChange', value);
        },
        onProfileContentValueChange(value) {
            let vm = this;
            vm.$emit('onProfileContentValueChange', value);
        },
        onElementWrapContentValueChange(value) {
            let vm = this;
            vm.$emit('onElementWrapContentValueChange', value);
        },
        onImageSelected(url) {
            let vm = this;
            vm.$emit('onImageSelected', url);
        },
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.editor-template-styles-properties {
    padding-top: 10px;
}
</style>